<div class="row_1">
    <div>
        <label class="label tab-heading titlered" (click)="openRouteLevel('shipments')">Shipments</label>
        <label class="label tab-heading" (click)="openRouteLevel('invoices')">Invoices</label>
        <label class="label tab-heading" (click)="openRouteLevel('transportation-entry')">Transportation Entry</label>
    </div>
    <div class="top_grid_agg">
        <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
        </app-notification-message>

        <div class="content">
            <div style="justify-content: left;">
                <button mat-raised-button class="black-btn" style="margin-left: 0px;" (click)="goBack();">BACK</button>
            </div>
            
            <div style="justify-content: right;">
                <button mat-raised-button class="black-btn" (click)="refreshData()">REFRESH</button>
                <button mat-raised-button class="black-btn" (click)="addShipmentsDetails()">ADD</button>
            </div>
        </div>

        <div class="grid-agg">
            <label class="gridcaption" style="text-align: left;">Shipment ID: {{shipmentId}}</label>
            <label class="gridcaption">Invoices</label>
            <ag-grid-angular
               [enableCellTextSelection]="true"
               [ngStyle]="{
                  'height': dynamicHeight + 'px', 'width':'100%', 'font-family':'Roboto' }"
                  id="LIOS-GRID"
                  class="ag-theme-balham"
                  (gridReady)="onGridReady($event);"
                  (window:resize)="sizeToFit()"
              [animateRows]="true"
              [defaultColDef]="defaultColDef"
              [columnDefs]="columnDefs"
              [rowData]="displayRowData"
              [context]="context"
              [pagination]="true"
              [paginationPageSize]="paginationPageSize"
              [icons]="icons"
              [overlayNoRowsTemplate]="'<span>No Records Found</span>'">
            </ag-grid-angular>
            <div class="custom-pagination" *ngIf="totalRecords > 0">
                <div class="left">
                    <span class="records-per-page">
                        <span>Records/Page : </span>
                        <select [(ngModel)]="rpPage" (change)="rppChanged($event)">
                            <option *ngFor="let size of pgDropDown" [value]="size.value">{{ size.value }}</option>
                        </select>
                    </span>
                </div>
                <div class="right">
                    <span class="viewing-records">
                    <span class="w-600">{{sRecord}}</span> to <span class="w-600">{{eRecord}}</span> of <span class="w-600">{{totalRecords}}</span>
                    <button (click)="goToFirstPage()" [disabled]="getCurrentPage() === true"><i class="fa-solid fa-backward-fast"
                        [ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                    <button (click)="goToPreviousPage()" [disabled]="getCurrentPage() === true"><i class="fa-solid fa-backward-step"
                        [ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                    <span>Page <span class="w-600">{{cPage}}</span> of <span class="w-600">{{tPage}}</span></span>
                    <button (click)="goToNextPage()" [disabled]="isLastPage() === true"><i class="fa-solid fa-forward-step"
                        [ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                    <button (click)="goToLastPage()" [disabled]="isLastPage() === true"><i class="fa-solid fa-forward-fast"
                        [ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
